var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTriangleDown = function SvgTriangleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5466 15.8167L17.0902 10.1373C17.4569 9.67895 17.1305 9 16.5436 9H7.45644C6.86948 9 6.54316 9.67895 6.90983 10.1373L11.4534 15.8167C11.7336 16.167 12.2664 16.167 12.5466 15.8167Z",
    fill: "currentColor"
  })));
};

export { SvgTriangleDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMi41NDY2IDE1LjgxNjdMMTcuMDkwMiAxMC4xMzczQzE3LjQ1NjkgOS42Nzg5NSAxNy4xMzA1IDkgMTYuNTQzNiA5SDcuNDU2NDRDNi44Njk0OCA5IDYuNTQzMTYgOS42Nzg5NSA2LjkwOTgzIDEwLjEzNzNMMTEuNDUzNCAxNS44MTY3QzExLjczMzYgMTYuMTY3IDEyLjI2NjQgMTYuMTY3IDEyLjU0NjYgMTUuODE2N1oiCiAgICAgICAgICBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";